<template>
  <div class="integracao-nuvemshop">
    <!-- Fundo atmosférico -->
    <div
      class="integracao-nuvemshop__bg"
      aria-hidden="true"
    >
      <div class="integracao-nuvemshop__bg-gradient" />
      <svg
        class="integracao-nuvemshop__mesh"
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="xMidYMid slice"
      >
        <defs>
          <linearGradient
            id="mesh-line"
            x1="0%"
            y1="0%"
            x2="100%"
            y2="100%"
          >
            <stop
              offset="0%"
              stop-color="#ffffff"
              stop-opacity="0.14"
            />
            <stop
              offset="100%"
              stop-color="#ffffff"
              stop-opacity="0.04"
            />
          </linearGradient>
        </defs>
        <!-- Malha / constelação -->
        <g
          stroke="url(#mesh-line)"
          stroke-width="0.6"
          fill="none"
        >
          <path d="M0,18% L22%,8% L45%,22% L68%,12% L100%,28%" />
          <path d="M0,42% L18%,35% L40%,48% L62%,38% L85%,52% L100%,45%" />
          <path d="M0,68% L25%,58% L50%,72% L75%,62% L100%,78%" />
          <path d="M12%,0 L8%,35% L15%,70% L12%,100%" />
          <path d="M38%,0 L42%,32% L35%,65% L40%,100%" />
          <path d="M62%,0 L58%,40% L65%,75% L60%,100%" />
          <path d="M88%,0 L92%,28% L85%,60% L90%,100%" />
          <path d="M22%,8% L40%,48% L58%,40% L68%,12%" />
          <path d="M18%,35% L50%,72% L75%,62%" />
        </g>
        <g fill="#ffffff">
          <circle
            cx="12%"
            cy="18%"
            r="1.8"
            opacity="0.35"
          />
          <circle
            cx="22%"
            cy="8%"
            r="1.2"
            opacity="0.5"
          />
          <circle
            cx="45%"
            cy="22%"
            r="1.5"
            opacity="0.4"
          />
          <circle
            cx="68%"
            cy="12%"
            r="1.3"
            opacity="0.45"
          />
          <circle
            cx="88%"
            cy="28%"
            r="1.6"
            opacity="0.35"
          />
          <circle
            cx="18%"
            cy="35%"
            r="1.1"
            opacity="0.4"
          />
          <circle
            cx="40%"
            cy="48%"
            r="1.4"
            opacity="0.38"
          />
          <circle
            cx="62%"
            cy="38%"
            r="1.2"
            opacity="0.42"
          />
          <circle
            cx="25%"
            cy="58%"
            r="1.3"
            opacity="0.32"
          />
          <circle
            cx="50%"
            cy="72%"
            r="1.5"
            opacity="0.36"
          />
          <circle
            cx="75%"
            cy="62%"
            r="1.1"
            opacity="0.4"
          />
        </g>
      </svg>
      <div class="integracao-nuvemshop__bokeh">
        <span /><span /><span /><span /><span /><span />
      </div>
    </div>

    <div class="integracao-nuvemshop__inner">
      <!-- Branding -->
      <header class="integracao-nuvemshop__brand">
        <div class="integracao-nuvemshop__logos">
          <div class="integracao-nuvemshop__logo-mc">
            <svg
              class="integracao-nuvemshop__mc-mark"
              viewBox="0 0 40 36"
              aria-hidden="true"
            >
              <path
                d="M8 32 L14 4 L20 4 L14 32 Z"
                fill="currentColor"
              />
              <path
                d="M22 32 L28 4 L34 4 L28 32 Z"
                fill="currentColor"
              />
            </svg>
            <span class="integracao-nuvemshop__logo-text">ManyConvert</span>
          </div>
          <span class="integracao-nuvemshop__plus">+</span>
          <div class="integracao-nuvemshop__logo-ns">
            <svg
              class="integracao-nuvemshop__ns-mark"
              viewBox="0 0 44 30"
              aria-hidden="true"
            >
              <!-- Nuvem / laços entrelaçados em branco sólido (referência) -->
              <path
                fill="currentColor"
                d="M34.2 12.3c-.2-4.3-3.8-7.7-8.2-7.7-2.4 0-4.6 1-6.1 2.6C18.4 4.9 15.1 3 11.5 3 6.3 3 2 7.3 2 12.5c0 .3 0 .6.1.9C.8 14.1 0 15.4 0 16.9 0 19.8 2.4 22.2 5.3 22.2h31.4c3.5 0 6.3-2.8 6.3-6.3 0-3.1-2.2-5.6-5.1-6.1l.3-.5zM22 8.5c2.8 0 5.1 2.1 5.4 4.8l.1.8h.8c2.2 0 3.9 1.8 3.9 3.9 0 .5-.1 1-.3 1.4H8.5c-1.4 0-2.5-1.1-2.5-2.5 0-1.1.7-2 1.7-2.4l.9-.3-.1-.9v-.3c0-3.6 2.9-6.5 6.5-6.5 1.8 0 3.4.7 4.6 1.9l.5.5.4-.6c1-1.4 2.6-2.3 4.4-2.3z"
              />
              <path
                fill="currentColor"
                opacity="0.72"
                d="M28 14c2.2 0 4 1.5 4.5 3.5h2.1c-.6-3.3-3.5-5.8-7-5.8-.8 0-1.6.1-2.3.4.8.5 1.4 1.2 1.7 1.9z"
              />
            </svg>
            <span class="integracao-nuvemshop__logo-text integracao-nuvemshop__logo-text--ns">nuvemshop</span>
          </div>
        </div>
        <div class="integracao-nuvemshop__brand-line" />
        <p class="integracao-nuvemshop__brand-tagline">
          Integração ManyConvert + Nuvemshop
        </p>
      </header>

      <!-- Hero -->
      <section class="integracao-nuvemshop__hero">
        <h1 class="integracao-nuvemshop__headline">
          Integração realizada com sucesso
        </h1>
        <p class="integracao-nuvemshop__subhead">
          Sua loja já está conectada à ManyConvert. Para concluir a ativação, preencha os dados abaixo.
        </p>
      </section>

      <!-- Card -->
      <div class="integracao-nuvemshop__card">
        <template v-if="!registrationComplete">
          <div class="integracao-nuvemshop__card-head">
            <h2 class="integracao-nuvemshop__card-title">
              Integração realizada com sucesso
            </h2>
            <p class="integracao-nuvemshop__card-desc">
              Sua loja já está conectada à ManyConvert. Para concluir a ativação, preencha os dados abaixo.
            </p>
          </div>

          <p
            v-if="!installationPublicId"
            class="integracao-nuvemshop__param-warning"
            role="alert"
          >
            Link inválido: falta o identificador da instalação. Abra novamente o endereço enviado pela integração.
          </p>

          <form
            class="integracao-nuvemshop__form"
            novalidate
            @submit.prevent="onSubmit"
          >
            <fieldset
              class="integracao-nuvemshop__fieldset"
              :disabled="loading"
            >
              <div class="integracao-nuvemshop__field">
                <label
                  class="integracao-nuvemshop__label"
                  for="field-ecommerce-name"
                >Nome do E-commerce</label>
                <input
                  id="field-ecommerce-name"
                  v-model.trim="form.ecommerceName"
                  type="text"
                  class="integracao-nuvemshop__input"
                  placeholder="Nome da Loja"
                  autocomplete="organization"
                  @input="clearError('ecommerceName')"
                >
                <p
                  v-if="errors.ecommerceName"
                  class="integracao-nuvemshop__error"
                >
                  {{ errors.ecommerceName }}
                </p>
              </div>

              <div class="integracao-nuvemshop__field">
                <label
                  class="integracao-nuvemshop__label"
                  for="field-ecommerce-url"
                >Link do E-commerce</label>
                <input
                  id="field-ecommerce-url"
                  v-model.trim="form.ecommerceUrl"
                  type="url"
                  class="integracao-nuvemshop__input"
                  placeholder="manyconvert.com ou https://www.sualoja.com.br"
                  inputmode="url"
                  autocomplete="url"
                  @input="clearError('ecommerceUrl')"
                  @blur="validateEcommerceUrlField"
                >
                <p
                  v-if="errors.ecommerceUrl"
                  class="integracao-nuvemshop__error"
                >
                  {{ errors.ecommerceUrl }}
                </p>
              </div>

              <div class="integracao-nuvemshop__field">
                <label
                  class="integracao-nuvemshop__label"
                  for="field-responsible"
                >Nome do Usuário Responsável</label>
                <input
                  id="field-responsible"
                  v-model.trim="form.responsibleName"
                  type="text"
                  class="integracao-nuvemshop__input"
                  placeholder="Seu Nome"
                  autocomplete="name"
                  @input="clearError('responsibleName')"
                >
                <p
                  v-if="errors.responsibleName"
                  class="integracao-nuvemshop__error"
                >
                  {{ errors.responsibleName }}
                </p>
              </div>

              <div class="integracao-nuvemshop__field">
                <label
                  class="integracao-nuvemshop__label"
                  for="field-email"
                >E-mail</label>
                <input
                  id="field-email"
                  v-model.trim="form.email"
                  type="email"
                  class="integracao-nuvemshop__input"
                  placeholder="seuemail@exemplo.com"
                  autocomplete="email"
                  @input="clearError('email')"
                  @blur="validateEmailField"
                >
                <p
                  v-if="errors.email"
                  class="integracao-nuvemshop__error"
                >
                  {{ errors.email }}
                </p>
              </div>

              <div class="integracao-nuvemshop__field">
                <label
                  class="integracao-nuvemshop__label"
                  for="field-whatsapp"
                >Número do WhatsApp</label>
                <div
                  class="integracao-nuvemshop__input-wrap"
                  :class="{ 'integracao-nuvemshop__input-wrap--invalid': errors.whatsapp }"
                >
                  <feather-icon
                    icon="PhoneIcon"
                    size="18"
                    class="integracao-nuvemshop__input-icon"
                  />
                  <input
                    id="field-whatsapp"
                    v-model="form.whatsapp"
                    v-mask="'(##) #####-####'"
                    type="tel"
                    class="integracao-nuvemshop__input integracao-nuvemshop__input--padded"
                    placeholder="(11) 99765-4321"
                    inputmode="numeric"
                    autocomplete="tel"
                    @input="clearError('whatsapp')"
                  >
                </div>
                <p
                  v-if="errors.whatsapp"
                  class="integracao-nuvemshop__error"
                >
                  {{ errors.whatsapp }}
                </p>
              </div>

              <div
                class="integracao-nuvemshop__whatsapp-note"
                role="note"
              >
                <span
                  class="integracao-nuvemshop__whatsapp-ico"
                  aria-hidden="true"
                >
                  <svg
                    viewBox="0 0 24 24"
                    width="22"
                    height="22"
                    fill="currentColor"
                  >
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.435 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
                  </svg>
                </span>
                <p class="integracao-nuvemshop__whatsapp-note-text">
                  A senha de acesso e as instruções de uso serão enviadas para o WhatsApp informado.
                </p>
              </div>

              <p
                v-if="submitError"
                class="integracao-nuvemshop__submit-error"
                role="alert"
              >
                {{ submitError }}
              </p>

              <button
                type="submit"
                class="integracao-nuvemshop__submit"
                :disabled="loading || !installationPublicId || registrationComplete"
              >
                <span
                  v-if="loading"
                  class="integracao-nuvemshop__spinner"
                  aria-hidden="true"
                />
                <span>{{ loading ? 'Enviando…' : 'Concluir cadastro' }}</span>
              </button>
            </fieldset>
          </form>
        </template>

        <div
          v-else
          class="integracao-nuvemshop__success"
          role="status"
          aria-live="polite"
        >
          <div
            class="integracao-nuvemshop__success-icon"
            aria-hidden="true"
          >
            <svg
              viewBox="0 0 48 48"
              width="56"
              height="56"
            >
              <defs>
                <linearGradient
                  id="integracao-success-ring"
                  x1="0%"
                  y1="0%"
                  x2="100%"
                  y2="100%"
                >
                  <stop
                    offset="0%"
                    stop-color="#7c3aed"
                  />
                  <stop
                    offset="100%"
                    stop-color="#db2777"
                  />
                </linearGradient>
                <linearGradient
                  id="integracao-success-check"
                  x1="0%"
                  y1="0%"
                  x2="100%"
                  y2="0%"
                >
                  <stop
                    offset="0%"
                    stop-color="#6d28d9"
                  />
                  <stop
                    offset="100%"
                    stop-color="#c026d3"
                  />
                </linearGradient>
              </defs>
              <circle
                cx="24"
                cy="24"
                r="22"
                fill="none"
                stroke="url(#integracao-success-ring)"
                stroke-width="2"
                opacity="0.35"
              />
              <path
                d="M14 24l8 8 12-14"
                fill="none"
                stroke="url(#integracao-success-check)"
                stroke-width="2.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <h2 class="integracao-nuvemshop__success-title">
            Cadastro concluído com sucesso
          </h2>
          <p class="integracao-nuvemshop__success-lead">
            Tudo certo — sua integração foi registrada.
          </p>
          <p class="integracao-nuvemshop__success-text">
            Os próximos passos e as instruções de uso foram enviados para o WhatsApp informado. Abra o aplicativo e siga as mensagens para finalizar a ativação. Esta página não permite um novo envio; se precisar de ajuda, fale com o suporte.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

const ONBOARDING_NUVEMSHOP_ADMIN_BASE = 'http://localhost:3000/api/onboarding/nuvemshop'

export default {
  name: 'IntegracaoNuvemshopConclusao',
  data() {
    return {
      form: {
        ecommerceName: '',
        ecommerceUrl: '',
        responsibleName: '',
        email: '',
        whatsapp: '',
      },
      errors: {},
      loading: false,
      /** Após resposta 2xx da API: oculta o formulário e impede novo envio nesta sessão. */
      registrationComplete: false,
      submitError: null,
    }
  },
  computed: {
    installationPublicId() {
      const id = this.$route.params.installation_public_id
      if (id === undefined || id === null) return null
      const s = String(id).trim()
      return s || null
    },
  },
  methods: {
    clearError(field) {
      if (this.errors[field]) {
        const next = { ...this.errors }
        delete next[field]
        this.errors = next
      }
    },
    digitsOnly(value) {
      return String(value || '').replace(/\D/g, '')
    },
    parseHttpUrl(value) {
      const t = String(value || '').trim()
      if (!t) return null
      try {
        return new URL(t)
      } catch {
        return null
      }
    },
    /**
     * Aceita também domínio sem protocolo (ex.: www.loja.com ou loja.com.br).
     */
    normalizeEcommerceUrlInput(value) {
      const s = String(value || '').trim()
      if (!s) return s
      if (/^https?:\/\//i.test(s)) return s
      if (/^\/\//.test(s)) return `https:${s}`
      return `https://${s}`
    },
    /**
     * E-mail: obrigatório, sem espaços, tamanho RFC, local + domínio com TLD (inclui .com.br).
     */
    getEmailValidationMessage(email) {
      const t = String(email || '').trim()
      if (!t) return 'Informe o e-mail.'
      if (t.length > 254) return 'E-mail muito longo.'
      if (/\s/.test(t)) return 'O e-mail não pode conter espaços.'
      const atCount = (t.match(/@/g) || []).length
      if (atCount !== 1) return 'Use um formato válido: nome@dominio.com'
      const [local, domain] = t.split('@')
      if (!local || !domain) return 'Use um formato válido: nome@dominio.com'
      if (local.length > 64) return 'A parte antes do @ é muito longa.'
      if (local.startsWith('.') || local.endsWith('.')) return 'Formato do e-mail inválido.'
      if (!/^[a-zA-Z0-9]([a-zA-Z0-9._%+-]*[a-zA-Z0-9])?$/.test(local)) {
        return 'Formato do e-mail inválido.'
      }
      if (!domain.includes('.')) return 'Informe um domínio válido (ex.: empresa.com.br).'
      if (domain.startsWith('.') || domain.endsWith('.') || domain.includes('..')) {
        return 'Domínio do e-mail inválido.'
      }
      const labels = domain.split('.')
      if (labels.some(l => !l || l.length > 63)) return 'Domínio do e-mail inválido.'
      if (!/^[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/.test(domain)) {
        return 'Digite um e-mail com domínio válido.'
      }
      return null
    },
    /**
     * Link da loja: http(s) ou domínio (www.loja.com / loja.com.br), URL válida após normalização.
     */
    getEcommerceUrlValidationMessage(url) {
      const t = String(url || '').trim()
      if (!t) return 'Informe o link da loja.'
      if (/\s/.test(t)) return 'O link não pode conter espaços.'
      const normalized = this.normalizeEcommerceUrlInput(t)
      const u = this.parseHttpUrl(normalized)
      if (!u) return 'Link inválido. Verifique o endereço digitado.'
      if (u.protocol !== 'http:' && u.protocol !== 'https:') {
        return 'Utilize apenas endereços http ou https.'
      }
      const host = u.hostname
      if (!host) {
        return 'Informe um endereço com domínio (ex.: https://www.sualoja.com.br).'
      }
      if (host.length > 253) return 'Endereço do site muito longo.'
      if (!host.includes('.')) {
        return 'Informe um domínio válido (ex.: www.sualoja.com.br).'
      }
      if (host.startsWith('.') || host.endsWith('.') || host.includes('..')) {
        return 'Domínio do link inválido.'
      }
      const hostLabels = host.split('.')
      if (hostLabels.some(l => !l || l.length > 63)) return 'Domínio do link inválido.'
      const labelRe = /^([a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)$/
      if (hostLabels.some(l => !labelRe.test(l))) return 'Domínio do link inválido.'
      return null
    },
    validateEmailField() {
      const t = this.form.email.trim()
      if (!t) {
        this.clearError('email')
        return
      }
      const msg = this.getEmailValidationMessage(t)
      if (msg && msg !== 'Informe o e-mail.') {
        this.errors = { ...this.errors, email: msg }
      } else if (!msg) {
        this.clearError('email')
      }
    },
    validateEcommerceUrlField() {
      const t = this.form.ecommerceUrl.trim()
      if (!t) {
        this.clearError('ecommerceUrl')
        return
      }
      const msg = this.getEcommerceUrlValidationMessage(t)
      if (msg && msg !== 'Informe o link da loja.') {
        this.errors = { ...this.errors, ecommerceUrl: msg }
      } else if (!msg) {
        this.clearError('ecommerceUrl')
      }
    },
    isValidWhatsappBR(value) {
      const d = this.digitsOnly(value)
      return d.length === 10 || d.length === 11
    },
    /** WhatsApp em E.164 para o Brasil (+55 + DDD + número). */
    formatWhatsappE164BR(value) {
      const d = this.digitsOnly(value)
      if (!d) return ''
      if (d.startsWith('55') && (d.length === 12 || d.length === 13)) {
        return `+${d}`
      }
      return `+55${d}`
    },
    extractApiErrorMessage(err) {
      const res = err && err.response
      const data = res && res.data
      if (!res) {
        return 'Falha na conexão. Verifique sua internet e tente novamente.'
      }
      if (typeof data === 'string' && data.trim()) return data.trim()
      if (data && typeof data.message === 'string' && data.message.trim()) {
        return data.message.trim()
      }
      if (data && typeof data.error === 'string' && data.error.trim()) {
        return data.error.trim()
      }
      if (res.status === 404) {
        return 'Instalação não encontrada. Verifique o link ou contate o suporte.'
      }
      if (res.status >= 500) {
        return 'Servidor indisponível no momento. Tente novamente em instantes.'
      }
      return 'Não foi possível concluir o cadastro. Tente novamente.'
    },
    validate() {
      const e = {}
      if (!this.form.ecommerceName) {
        e.ecommerceName = 'Informe o nome do e-commerce.'
      }
      const urlMsg = this.getEcommerceUrlValidationMessage(this.form.ecommerceUrl)
      if (urlMsg) e.ecommerceUrl = urlMsg
      const emailMsg = this.getEmailValidationMessage(this.form.email)
      if (emailMsg) e.email = emailMsg
      if (!this.form.responsibleName) {
        e.responsibleName = 'Informe o nome do responsável.'
      }
      if (!this.form.whatsapp || !this.digitsOnly(this.form.whatsapp).length) {
        e.whatsapp = 'Informe o WhatsApp com DDD.'
      } else if (!this.isValidWhatsappBR(this.form.whatsapp)) {
        e.whatsapp = 'WhatsApp inválido. Use DDD + número (10 ou 11 dígitos).'
      }
      this.errors = e
      return Object.keys(e).length === 0
    },
    async onSubmit() {
      if (this.registrationComplete) return
      if (!this.validate()) return
      if (!this.installationPublicId) {
        this.submitError = 'Identificador da instalação ausente. Use o link completo enviado pela integração.'
        return
      }
      this.submitError = null
      this.loading = true
      const url = `${ONBOARDING_NUVEMSHOP_ADMIN_BASE}/${encodeURIComponent(
        this.installationPublicId,
      )}/admin`
      const payload = {
        name: this.form.responsibleName.trim(),
        email: this.form.email.trim(),
        whatsapp: this.formatWhatsappE164BR(this.form.whatsapp),
        storeName: this.form.ecommerceName.trim(),
      }
      try {
        await axios.post(url, payload, {
          headers: { 'Content-Type': 'application/json' },
        })
        this.registrationComplete = true
      } catch (err) {
        this.submitError = this.extractApiErrorMessage(err)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
// Paleta ManyConvert (referência visual)
$mc-purple-deep: #3b0764;
$mc-purple: #5b21b6;
$mc-violet: #7c3aed;
$mc-magenta: #c026d3;
$mc-fuchsia: #e879f9;
$mc-pink-glow: #fbcfe8;
$mc-card-title: #5b21b6;
$mc-text-muted: #6b5a7a;
$mc-input-border: #e9e0f0;
$mc-note-bg: #fff4e8;
$mc-note-text: #5c4a42;
$mc-error: #9d174d;

.integracao-nuvemshop {
  position: relative;
  min-height: 100vh;
  width: 100%;
  overflow-x: hidden;
  font-family: 'Montserrat', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  -webkit-font-smoothing: antialiased;
}

.integracao-nuvemshop__bg {
  position: fixed;
  inset: 0;
  z-index: 0;
  pointer-events: none;
}

.integracao-nuvemshop__bg-gradient {
  position: absolute;
  inset: 0;
  background:
    radial-gradient(ellipse 120% 80% at 85% 15%, rgba($mc-fuchsia, 0.55) 0%, transparent 55%),
    radial-gradient(ellipse 90% 70% at 10% 90%, rgba($mc-purple-deep, 0.45) 0%, transparent 50%),
    radial-gradient(ellipse 60% 50% at 50% 50%, rgba($mc-magenta, 0.25) 0%, transparent 60%),
    linear-gradient(
      118deg,
      #2d0a52 0%,
      #4c1d95 18%,
      #6d28d9 38%,
      #a21caf 58%,
      #db2777 78%,
      #fda4af 100%
    );
}

.integracao-nuvemshop__mesh {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  opacity: 1;
}

.integracao-nuvemshop__bokeh {
  position: absolute;
  inset: 0;
  overflow: hidden;

  span {
    position: absolute;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.35);
    filter: blur(40px);
    animation: integracao-float 14s ease-in-out infinite;

    &:nth-child(1) {
      width: 180px;
      height: 180px;
      top: 12%;
      left: 8%;
      opacity: 0.25;
      animation-delay: 0s;
    }
    &:nth-child(2) {
      width: 120px;
      height: 120px;
      top: 55%;
      right: 12%;
      opacity: 0.2;
      animation-delay: -3s;
    }
    &:nth-child(3) {
      width: 220px;
      height: 220px;
      bottom: 5%;
      left: 25%;
      opacity: 0.18;
      animation-delay: -6s;
    }
    &:nth-child(4) {
      width: 90px;
      height: 90px;
      top: 30%;
      right: 30%;
      opacity: 0.22;
      animation-delay: -2s;
    }
    &:nth-child(5) {
      width: 140px;
      height: 140px;
      bottom: 35%;
      right: 8%;
      opacity: 0.15;
      animation-delay: -8s;
    }
    &:nth-child(6) {
      width: 100px;
      height: 100px;
      top: 70%;
      left: 15%;
      opacity: 0.2;
      animation-delay: -4s;
    }
  }
}

@keyframes integracao-float {
  0%,
  100% {
    transform: translate(0, 0) scale(1);
  }
  50% {
    transform: translate(12px, -10px) scale(1.05);
  }
}

.integracao-nuvemshop__inner {
  position: relative;
  z-index: 1;
  max-width: 560px;
  margin: 0 auto;
  padding: 2.5rem 1.25rem 3.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.integracao-nuvemshop__brand {
  text-align: center;
  width: 100%;
  margin-bottom: 2.25rem;
}

.integracao-nuvemshop__logos {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 0.65rem 1rem;
  color: #fff;
}

.integracao-nuvemshop__logo-mc,
.integracao-nuvemshop__logo-ns {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.integracao-nuvemshop__mc-mark {
  width: 28px;
  height: auto;
  flex-shrink: 0;
}

.integracao-nuvemshop__ns-mark {
  width: 32px;
  height: auto;
  flex-shrink: 0;
}

.integracao-nuvemshop__logo-text {
  font-size: 1.05rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  white-space: nowrap;

  &--ns {
    font-weight: 500;
    letter-spacing: 0.01em;
  }
}

.integracao-nuvemshop__plus {
  font-size: 1.35rem;
  font-weight: 300;
  opacity: 0.95;
  line-height: 1;
  padding: 0 0.15rem;
}

.integracao-nuvemshop__brand-line {
  width: min(32%, 200px);
  height: 1px;
  margin: 1.15rem auto 0.85rem;
  background: rgba(255, 255, 255, 0.35);
}

.integracao-nuvemshop__brand-tagline {
  margin: 0;
  font-size: 0.8125rem;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.92);
  letter-spacing: 0.03em;
}

.integracao-nuvemshop__hero {
  text-align: center;
  margin-bottom: 2rem;
  max-width: 480px;
}

.integracao-nuvemshop__headline {
  margin: 0 0 1rem;
  font-size: clamp(1.5rem, 4.5vw, 2rem);
  font-weight: 700;
  color: #fff;
  line-height: 1.2;
  letter-spacing: -0.02em;
  text-shadow: 0 2px 24px rgba(0, 0, 0, 0.12);
}

.integracao-nuvemshop__subhead {
  margin: 0;
  font-size: 0.9375rem;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.95);
  line-height: 1.65;
}

.integracao-nuvemshop__card {
  width: 100%;
  background: rgba(255, 255, 255, 0.97);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border-radius: 28px;
  box-shadow:
    0 4px 6px rgba(91, 33, 182, 0.06),
    0 24px 48px rgba(45, 10, 82, 0.18),
    0 0 0 1px rgba(255, 255, 255, 0.5) inset;
  padding: 2.5rem 2.25rem 2.75rem;
}

.integracao-nuvemshop__card-head {
  text-align: center;
  margin-bottom: 2rem;
}

.integracao-nuvemshop__card-title {
  margin: 0 0 0.75rem;
  font-size: 1.375rem;
  font-weight: 700;
  color: $mc-card-title;
  line-height: 1.25;
}

.integracao-nuvemshop__card-desc {
  margin: 0;
  font-size: 0.875rem;
  font-weight: 400;
  color: $mc-text-muted;
  line-height: 1.65;
}

.integracao-nuvemshop__form {
  display: flex;
  flex-direction: column;
  gap: 1.35rem;
}

.integracao-nuvemshop__fieldset {
  border: none;
  margin: 0;
  padding: 0;
  min-width: 0;
}

.integracao-nuvemshop__field {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.integracao-nuvemshop__label {
  font-size: 0.75rem;
  font-weight: 700;
  color: $mc-card-title;
  letter-spacing: 0.02em;
}

.integracao-nuvemshop__input-wrap {
  position: relative;
  display: flex;
  align-items: center;

  &--invalid .integracao-nuvemshop__input {
    border-color: rgba($mc-error, 0.45);
  }
}

.integracao-nuvemshop__input-icon {
  position: absolute;
  left: 14px;
  color: #9ca3af;
  pointer-events: none;
  z-index: 1;
}

.integracao-nuvemshop__input {
  width: 100%;
  height: 52px;
  padding: 0 16px;
  font-size: 0.9375rem;
  font-family: inherit;
  color: #1f1630;
  background: #fff;
  border: 1px solid $mc-input-border;
  border-radius: 10px;
  outline: none;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  &::placeholder {
    color: #b8b0c4;
  }

  &:focus {
    border-color: rgba($mc-violet, 0.55);
    box-shadow: 0 0 0 3px rgba($mc-violet, 0.12);
  }

  &--padded {
    padding-left: 44px;
  }
}

.integracao-nuvemshop__error {
  margin: 0;
  font-size: 0.75rem;
  font-weight: 500;
  color: $mc-error;
  letter-spacing: 0.01em;
}

.integracao-nuvemshop__param-warning {
  margin: 0 0 1.25rem;
  padding: 0.85rem 1rem;
  font-size: 0.8125rem;
  font-weight: 500;
  line-height: 1.45;
  color: $mc-error;
  background: rgba($mc-error, 0.06);
  border: 1px solid rgba($mc-error, 0.2);
  border-radius: 10px;
}

.integracao-nuvemshop__submit-error {
  margin: 0 0 0.75rem;
  font-size: 0.8125rem;
  font-weight: 500;
  line-height: 1.45;
  color: $mc-error;
  text-align: center;
}

.integracao-nuvemshop__whatsapp-note {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 0.9rem 1rem;
  background: $mc-note-bg;
  border-radius: 10px;
  border: 1px solid rgba(237, 200, 170, 0.45);
}

.integracao-nuvemshop__whatsapp-ico {
  flex-shrink: 0;
  color: #128c7e;
  margin-top: 1px;
}

.integracao-nuvemshop__whatsapp-note-text {
  margin: 0;
  font-size: 0.8125rem;
  line-height: 1.5;
  color: $mc-note-text;
  font-weight: 500;
}

.integracao-nuvemshop__submit {
  margin-top: 0.35rem;
  width: 100%;
  height: 54px;
  border: none;
  border-radius: 12px;
  font-family: inherit;
  font-size: 1rem;
  font-weight: 700;
  color: #fff;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  background: linear-gradient(90deg, #6d28d9 0%, #9333ea 45%, #db2777 100%);
  box-shadow:
    0 4px 16px rgba(124, 58, 237, 0.45),
    0 2px 6px rgba(219, 39, 119, 0.25);
  transition: transform 0.2s ease, box-shadow 0.2s ease, filter 0.2s ease;

  &:hover:not(:disabled) {
    transform: translateY(-1px);
    filter: brightness(1.05);
    box-shadow:
      0 8px 24px rgba(124, 58, 237, 0.5),
      0 4px 10px rgba(219, 39, 119, 0.3);
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }

  &:disabled {
    cursor: wait;
    opacity: 0.88;
    transform: none;
  }
}

.integracao-nuvemshop__spinner {
  width: 1.1rem;
  height: 1.1rem;
  border: 2px solid rgba(255, 255, 255, 0.35);
  border-top-color: #fff;
  border-radius: 50%;
  animation: integracao-spin 0.7s linear infinite;
}

@keyframes integracao-spin {
  to {
    transform: rotate(360deg);
  }
}

.integracao-nuvemshop__success {
  text-align: center;
  padding: 1rem 0 0.5rem;
}

.integracao-nuvemshop__success-icon {
  margin-bottom: 1.25rem;
  display: flex;
  justify-content: center;
}

.integracao-nuvemshop__success-title {
  margin: 0 0 0.65rem;
  font-size: 1.35rem;
  font-weight: 700;
  color: $mc-card-title;
  line-height: 1.25;
}

.integracao-nuvemshop__success-lead {
  margin: 0 0 0.85rem;
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.5;
  color: #3f2d52;
}

.integracao-nuvemshop__success-text {
  margin: 0;
  font-size: 0.9375rem;
  font-weight: 400;
  line-height: 1.65;
  color: $mc-text-muted;
}

@media (max-width: 575.98px) {
  .integracao-nuvemshop__inner {
    padding: 1.75rem 1rem 2.5rem;
  }

  .integracao-nuvemshop__brand {
    margin-bottom: 1.75rem;
  }

  .integracao-nuvemshop__hero {
    margin-bottom: 1.5rem;
  }

  .integracao-nuvemshop__headline {
    font-size: 1.4rem;
  }

  .integracao-nuvemshop__subhead {
    font-size: 0.875rem;
  }

  .integracao-nuvemshop__card {
    padding: 1.75rem 1.35rem 2rem;
    border-radius: 22px;
  }

  .integracao-nuvemshop__card-head {
    margin-bottom: 1.5rem;
  }

  .integracao-nuvemshop__form {
    gap: 1.15rem;
  }

  .integracao-nuvemshop__logos {
    gap: 0.5rem 0.75rem;
  }

  .integracao-nuvemshop__logo-text {
    font-size: 0.95rem;
  }
}
</style>
